module.exports = __webpack_public_path__ + "static/img/logo.ccfa15f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 13